import React from 'react';

import Navbar from './Navbar';
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import Experience from './Experience';
import Skills from './Skills';
import HonoursAwards from './HonoursAwards';
import Contact from './Contact';
import Footer from './Footer';
import ScrollToTopButton from './ScrollToTopButton';
import OpenSourceProfile from './OpenSourceProfile';
import Hobby from './Hobby';
import Playground from './Playground';

import ProofStrip from './ProofStrip';
import { LensProvider } from './LensContext';
import useReveal from './useReveal';

function AppContent() {
    useReveal();

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <ProofStrip />
                <div className="content-sections container">
                    <section id="about">
                        <About />
                    </section>
                    <section id="experience">
                        <Experience />
                    </section>
                    <section id="projects">
                        <Projects />
                    </section>
                    <section id="skills">
                        <Skills />
                    </section>
                    <section id="honours">
                        <HonoursAwards />
                    </section>
                    <section id="oss">
                        <OpenSourceProfile />
                    </section>
                    <section id="hobby">
                        <Hobby />
                    </section>
                    <section id="playground">
                        <Playground />
                    </section>
                    <section id="contact">
                        <Contact />
                    </section>
                </div>
            </main>
        </>
    );
}

function App() {
    return (
        <LensProvider>
            <div className="app-container">
                <AppContent />
                <Footer />
                <ScrollToTopButton />
            </div>
        </LensProvider>
    );
}

export default App;
